import { uniqueId } from 'lodash';
/**
 * Internal dependencies
 */
import { NOTICE_CREATE, NOTICE_REMOVE } from 'state/action-types';


export const removeNotice = (noticeId) => {
    return {
        noticeId: noticeId,
        type: NOTICE_REMOVE,
    };
}


export const createNotice = (status, text, { id, ...noticeOptions } = {}) => {
    return {
        type: NOTICE_CREATE,
        notice: Object.assign({ showDismiss: true }, noticeOptions, {
            noticeId: id || uniqueId(),
            status,
            text,
        }),
    };
}

export const successNotice = createNotice.bind(null, 'is-success');
export const errorNotice = createNotice.bind(null, 'is-error');
export const infoNotice = createNotice.bind(null, 'is-info');
export const warningNotice = createNotice.bind(null, 'is-warning');
export const plainNotice = createNotice.bind(null, 'is-plain');
